import { AchievementItemType } from './achievement-item';

export const AllAchievementsComplete = (
  areAchievementsCompleted?: boolean
): AchievementItemType[] => [
  {
    icon: 'star',
    title: 'DASHBOARD.NEW_DASHBOARD.ACHIEVEMENTS.COMPLETE.TITLE',
    subtitle: 'DASHBOARD.NEW_DASHBOARD.ACHIEVEMENTS.COMPLETE.SUBTITLE',
    isCompleted: areAchievementsCompleted,
    to: '/',
    achievementKey: 'all-achievements-complete',
  },
];
